<template>
	<modal ref="modal">
		<template #title>
			<span v-if="member!=null">{{ `Follow Up: ${member.fname} ${member.lname}` }}</span>
		</template>
		<template #body>
			<div v-if="member!=null">
				<p class="mb-2 border p-4 py-2 px-3">{{ member.fname }} {{member.lname}}</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ member.email }}</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ member.mobile }}</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ member.current_rank }}</p>
				<p class="mb-2 border p-4 py-2 px-3">
					{{ member.mop }}
				</p>
				<p class="mb-2 border p-4 py-2 px-3">{{ member.status }}</p>
				<div class="mb-4">
					<label for="status" class="form-label">Enter Status</label>
					<select
						v-model="form.status"
						class="form-select"
						:class="{ 'is-invalid': form.errors.status }"
						id="status"
					>
						<option selected value="" disabled>Enter Status</option>
                        <option value="will not renew">Will not renew (Email)</option>
                        <option value="will renew next time">Will renew next time (Email and SMS)</option>
                        <option value="call not answered">Call not answered (Email and SMS)</option>
                        <option value="number incorrect">Number Incorrect (Email)</option>
                        <option value="international number">International Number (Email)</option>
                        <option value="requested for callback">Requested for callback (Email and SMS)</option>
                        <option v-if="member.member_status=='Renewed'" value="renewed">Renewed (Email and SMS)</option>
                        <option v-if="member.member_status=='Renewed'" value="cs auto renewed">CS Auto Renewed</option>
					</select>
					<div v-if="form.errors.status" class="invalid-feedback">
						{{ form.errors.status }}
					</div>
				</div>
				<div class="mb-4">
					<label
						for="remarks"
						class="form-label"
						:class="{ 'is-invalid': form.errors.remarks }"
						>Follow-up Remarks</label
					>
					<textarea
						v-model="form.remarks"
						class="form-control"
						row="5"
					></textarea>
					<div v-if="form.errors.remarks" class="invalid-feedback">
						{{ form.errors.remarks }}
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="followUp"
				type="button"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<i class="fa fa-arrow-circle-up me-1"></i>
				<span v-if="!form.processing">Follow Up</span>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary" :disabled="form.processing">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { ref, toRef, toRefs, watch } from 'vue'

export default {
	props: {

	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			member_id 			: null,
			expired_member_id 	: null,
			ops_request_id 		: null,
			txnid 				: null,
			email 				: null,
			status 				: null,
			remarks 			: null,
			is_expired			: 1
		})

		const member = ref(null);

		const setMember = (data)=>{ 
							member.value 			= data;

							form.expired_member_id 	= data.expired_member_id;
							form.member_id 			= data.member_id;
							form.ops_request_id 	= data.counter;
							form.txnid 				= data.txnid;
							form.email 				= data.email;
						}

		const followUp = () => {
			form.post(route('admin.transactions.post.expired-followup'), {
				preserveState: true,
				preserveScroll: true,
				only:['expiredMembers','totalStatus','followUp','api_response'],
				onSuccess: () => {
					form.reset('status', 'remarks');
					toggleModal();
				},
			})
		}

		return {
			modal,
			form,
			setMember,
			member,
			followUp,
			toggleModal,
		}
	},
}
</script>
